import React from 'react';

const S = {
  card:  { margin: '10px 0 14px', padding: '14px 16px', background: 'rgba(6,14,40,0.55)', border: '1px solid rgba(56,189,248,0.12)', borderRadius: 12, fontFamily: 'inherit' },
  label: { fontSize: 9.5, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'rgba(56,189,248,0.55)', display: 'block', marginBottom: 10 },
};

export function ProgressCard({ title = 'Progresso', percentage = 0, items = [] }) {
  const pct = Math.min(100, Math.max(0, percentage));
  return (
    <div style={S.card}>
      <span style={S.label}>{title}</span>

      {/* Progress bar */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
        <div style={{ flex: 1, height: 5, background: 'rgba(255,255,255,0.06)', borderRadius: 3, overflow: 'hidden' }}>
          <div style={{
            width: `${pct}%`, height: '100%',
            background: 'linear-gradient(90deg,#818cf8,#38bdf8)',
            borderRadius: 3, transition: 'width .8s ease',
          }} />
        </div>
        <span style={{ fontSize: 12, color: '#38bdf8', fontWeight: 600, minWidth: 34, textAlign: 'right' }}>
          {pct}%
        </span>
      </div>

      {/* Items */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {items.map((item, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ color: item.done ? '#10b981' : 'rgba(100,116,139,0.4)', fontSize: 13, flexShrink: 0, lineHeight: 1 }}>
              {item.done ? '✓' : '○'}
            </span>
            <span style={{ fontSize: 12.5, color: item.done ? 'rgba(220,228,255,0.78)' : 'rgba(100,116,139,0.5)', lineHeight: 1.35 }}>
              {item.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
